<template>
    <div class="container">
        <!-- 背景层：gif用css背景图确保iOS播放，静态图覆盖其上；说话时隐藏静态图露出gif动画 -->
        <div class="bg-img bg-gif"></div>
        <img
            class="bg-img bg-static"
            :class="{ speaking: isSpeaking }"
            src="/static/t2.png"
            alt=""
        />
        <div class="overlay"></div>

        <!-- 左上角：菜单按钮 -->
        <div class="menu-btn" @click="sidebarToggle">
            <div class="menu-icon">
                <div class="menu-line" :class="{ open: sidebarShow }"></div>
                <div class="menu-line" :class="{ open: sidebarShow }"></div>
                <div class="menu-line" :class="{ open: sidebarShow }"></div>
            </div>
        </div>

        <!-- 右上角：普通模式 新会话/生成报告；评估模式 新会话（结束当前评估重开） -->
        <div class="top-right" v-if="!isAssessmentMode">
            <div class="top-btn" @click="sidebarOpenNewSession">
                <span class="top-btn-text">新会话</span>
            </div>
            <div class="top-btn top-btn-primary" @click="sidebarOpenReport">
                <span class="top-btn-text">生成报告</span>
            </div>
        </div>
        <div class="top-right" v-if="isAssessmentMode">
            <div class="top-btn" @click="sidebarQuitAssessment">
                <span class="top-btn-text">新会话</span>
            </div>
        </div>

        <!-- 侧边栏遮罩 -->
        <div class="sidebar-mask" :class="{ active: sidebarShow }" @click="sidebarClose"></div>

        <!-- 左侧侧边栏 -->
        <div class="sidebar" :class="{ active: sidebarShow }">
            <div class="sidebar-header">
                <span class="sidebar-title">历史记录</span>
            </div>
            <div class="sidebar-body">
                <!-- 加载中 -->
                <div v-if="sidebarLoading" class="sidebar-loading">
                    <span>加载中...</span>
                </div>
                <!-- 空状态 -->
                <div v-else-if="sidebarConversations.length === 0" class="sidebar-empty">
                    <span class="empty-icon-text">📝</span>
                    <span class="empty-desc">暂无历史记录</span>
                </div>
                <!-- 会话卡片列表 -->
                <div class="sidebar-card" v-for="(item, idx) in sidebarConversations" :key="idx">
                    <div class="sidebar-card-main" @click="sidebarViewConversation(item)">
                        <span class="sidebar-card-summary">{{ item.summary }}</span>
                        <div class="sidebar-card-meta">
                            <span class="sidebar-card-date">
                                {{ sidebarFormatDate(item.lastMessageAt) }}
                            </span>
                            <span class="sidebar-card-count">{{ item.messageCount }}条</span>
                        </div>
                    </div>
                    <!-- 有报告时显示跳转按钮 -->
                    <div
                        v-if="item.hasReport"
                        class="sidebar-card-report"
                        @click.stop="sidebarViewReport(item)"
                    >
                        <span class="report-text">查看总结报告</span>
                    </div>
                </div>
            </div>
            <!-- 底部切换模式 + 退出登录 -->
            <div class="sidebar-footer">
                <div class="switch-mode-btn" @click="sidebarSwitchMode">
                    <span class="switch-mode-label">切换模式</span>
                </div>
                <div class="logout-btn-sidebar" @click="sidebarHandleLogout">
                    <span class="logout-label">退出登录</span>
                </div>
            </div>
        </div>

        <!-- 历史详情弹窗 -->
        <div class="detail-mask" v-if="sidebarShowDetail" @click="sidebarShowDetail = false">
            <div class="detail-panel" @click.stop>
                <div class="detail-header">
                    <span class="detail-title">对话详情</span>
                </div>
                <div class="detail-body">
                    <div
                        class="detail-msg"
                        :class="msg.type"
                        v-for="(msg, idx) in sidebarDetailMessages"
                        :key="idx"
                    >
                        <div class="detail-avatar" :class="msg.type">
                            <span>{{ msg.type === 'bot' ? '小酒窝' : '我' }}</span>
                        </div>
                        <div class="detail-bubble" :class="msg.type">
                            <span class="detail-content">{{ msg.content }}</span>
                        </div>
                    </div>
                    <div v-if="sidebarDetailMessages.length === 0" class="sidebar-empty">
                        <span class="empty-desc">暂无消息</span>
                    </div>
                </div>
                <div class="detail-footer">
                    <span class="detail-close-btn" @click="sidebarShowDetail = false">关闭</span>
                </div>
            </div>
        </div>

        <!-- 通用确认弹窗（新会话 / 生成报告共用，含描述与取消、确认按钮） -->
        <div class="end-mask" v-if="sidebarShowConfirm" @click="sidebarShowConfirm = false">
            <div class="end-panel" @click.stop>
                <span class="end-panel-title">
                    {{ sidebarConfirmType === 'report' ? '生成总结报告？' : '开始新会话？' }}
                </span>
                <span class="end-panel-desc">
                    {{
                        sidebarConfirmType === 'report'
                            ? '将基于本次对话内容生成总结报告，并结束当前对话。'
                            : '当前对话将结束并清空，开启一段全新的对话。'
                    }}
                </span>
                <div class="end-panel-btns">
                    <div class="end-btn end-btn-secondary" @click="sidebarShowConfirm = false">
                        <span class="end-btn-text">取消</span>
                    </div>
                    <div class="end-btn end-btn-primary" @click="sidebarConfirmAction">
                        <span class="end-btn-text">确认</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 聊天消息区域 -->
        <div class="chat-area" ref="chatArea">
            <div class="chat-list">
                <div v-for="(msg, index) in messages" :key="index" class="message-item">
                    <!-- 思考中消息 -->
                    <div class="message-bubble thinking-bubble" v-if="msg.type === 'thinking'">
                        <span class="bot-name">小酒窝：</span>
                        <span class="thinking-content">
                            <span class="thinking-text">{{ chatThinkingText }}</span>
                            <span class="thinking-dots">
                                <span class="dot" v-for="i in 3" :key="i"></span>
                            </span>
                        </span>
                    </div>
                    <!-- 普通消息 -->
                    <div class="message-bubble" v-else>
                        <span>
                            <span class="bot-name" v-if="msg.type === 'bot'">小酒窝：</span>
                            <span class="user-name" v-if="msg.type === 'user'">我：</span>
                            {{ msg.content }}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部输入区域 -->
        <div class="input-area">
            <div class="input-wrapper">
                <!-- 语音/键盘切换按钮 -->
                <div class="switch-btn" @click="audioToggleInputMode">
                    <img
                        class="switch-icon"
                        :class="{ rotate: chatIsVoiceMode }"
                        :src="chatIsVoiceMode ? '/static/keyboard.png' : '/static/voice.png'"
                        alt=""
                    />
                </div>
                <!-- 键盘输入模式 -->
                <div class="input-content" :class="{ hidden: chatIsVoiceMode }">
                    <input
                        class="chat-input"
                        v-model="inputText"
                        placeholder="说点什么..."
                        @keyup.enter="chatSendMessage"
                        @focus="audioUnlock"
                    />
                    <div
                        class="send-btn"
                        :class="{ active: inputText.trim() }"
                        @click="chatSendMessage"
                    >
                        <span>发送</span>
                    </div>
                </div>
                <!-- 语音输入模式（同时支持触屏与PC鼠标按住说话） -->
                <div class="input-content voice-content" :class="{ hidden: !chatIsVoiceMode }">
                    <div
                        class="voice-input-wrap"
                        :class="{ recording: audioIsRecording }"
                        @touchstart.prevent="audioStartRecord"
                        @touchend.prevent="audioStopRecord"
                        @touchcancel.prevent="audioCancelRecord"
                        @mousedown.prevent="audioStartRecord"
                        @mouseup.prevent="audioStopRecord"
                        @mouseleave="audioCancelRecord"
                        @contextmenu.prevent
                    >
                        <span class="voice-text">
                            {{ audioIsRecording ? '松开 结束' : '按住 说话' }}
                        </span>
                    </div>
                </div>
            </div>

            <!-- 录制时悬浮波纹 -->
            <div class="floating-wave" v-if="audioIsRecording">
                <div class="fw-bars">
                    <div
                        class="fw-bar"
                        v-for="i in 7"
                        :key="i"
                        :style="{ animationDelay: i * 0.1 + 's' }"
                    ></div>
                </div>
                <span class="fw-time">{{ audioRecordTime }}s</span>
            </div>
        </div>
    </div>
</template>

<script>
import audioMixin from './mixins/audioMixin.js';
import chatMixin from './mixins/chatMixin.js';
import assessmentMixin from './mixins/assessmentMixin.js';
import sidebarMixin from './mixins/sidebarMixin.js';
import { getStorage, removeStorage } from '@/utils/storage.js';

export default {
    name: 'ChatIndex',
    mixins: [audioMixin, chatMixin, assessmentMixin, sidebarMixin],

    data() {
        return {
            inputText: '', // 输入框文本内容
            isSpeaking: false, // 小酒窝是否在说话（控制背景gif显隐）
            messages: [], // 聊天消息列表（各mixin共享）
            chatMode: 'chat', // 聊天模式：choice页带 type=assessment 进入则为评估模式，默认普通聊天（决定恢复哪类会话）
        };
    },

    created() {
        // 从路由参数确定聊天模式：模式选择页「心理评估」带 type=assessment，默认普通聊天
        this.chatMode = this.$route.query.type === 'assessment' ? 'assessment' : 'chat';

        // iOS Safari: 被遮挡的gif不会启动动画解码，需要短暂露出触发播放
        this.isSpeaking = true;
        setTimeout(() => {
            this.isSpeaking = false;
        }, 150);

        // 先初始化音频播放器（必须在恢复会话之前，否则欢迎语无法播放）
        this.audioInitPlayer();

        // 按入口模式只恢复对应类型未结束的会话（普通聊天/评估互不可见）
        this.chatRestoreConversation().then(() => {
            // 主动开始评估（用户从模式选择页选择「心理评估」时写入的标记）
            const needAssessment = getStorage('needAssessment');
            if (needAssessment) {
                removeStorage('needAssessment');
                this.assessmentStartMode();
            }
        });
    },

    beforeDestroy() {
        // 清理录音计时器
        if (this.audioRecordTimer) {
            clearInterval(this.audioRecordTimer);
        }
        // 清理打字机计时器
        if (this.chatTypingTimer) {
            clearInterval(this.chatTypingTimer);
        }
        // 清理思考中计时器
        if (this.chatThinkingTimer) {
            clearTimeout(this.chatThinkingTimer);
            clearInterval(this.chatThinkingTimer);
        }
        // 停止音频播放
        this.audioStop();
    },
};
</script>

<style lang="scss" scoped>
.container {
    position: relative;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
}

// 背景图片基础样式
.bg-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
}

// gif层（用css背景图，避免iOS Safari对img标签的懒加载导致gif不播放）
.bg-gif {
    z-index: 1;
    background-image: url('/static/t1.gif');
    background-size: cover;
    background-position: center;
}

// 静态图层（顶层，默认可见；说话时隐藏，露出下层gif）
.bg-static {
    z-index: 2;
    object-fit: cover; // 对应原 image 的 aspectFill
    transition: opacity 0.3s ease;

    &.speaking {
        opacity: 0;
    }
}

// 左上角菜单按钮
.menu-btn {
    position: absolute;
    top: 80rpx;
    left: 30rpx;
    z-index: 10;
    width: 72rpx;
    height: 72rpx;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.55);
    border-radius: 50%;
    border: 2rpx solid rgba(255, 255, 255, 0.7);
    box-shadow: 0 4rpx 20rpx rgba(0, 0, 0, 0.1);

    &:active {
        opacity: 0.8;
        transform: scale(0.92);
    }
}

// 右上角按钮组（相邻按钮用 margin 间距，替代 gap 保证兼容性）
.top-right {
    position: absolute;
    top: 80rpx;
    right: 30rpx;
    z-index: 10;
    display: flex;

    .top-btn + .top-btn {
        margin-left: 16rpx;
    }
}

// 顶部通用按钮
.top-btn {
    padding: 10rpx 30rpx;
    background: rgba(255, 255, 255, 0.55);
    border-radius: 30rpx;
    border: 2rpx solid rgba(255, 255, 255, 0.7);
    box-shadow: 0 4rpx 20rpx rgba(0, 0, 0, 0.1);

    &:active {
        opacity: 0.8;
        transform: scale(0.95);
    }

    .top-btn-text {
        font-size: 24rpx;
        color: #5a3a3a;
        font-weight: 600;
    }
}

// 主按钮（生成报告）：品牌渐变高亮，与次要按钮拉开视觉层级
.top-btn-primary {
    background: linear-gradient(135deg, #f4a261, #e8735a);
    border-color: rgba(255, 255, 255, 0.5);
    box-shadow: 0 6rpx 20rpx rgba(232, 115, 90, 0.35);

    .top-btn-text {
        color: #ffffff;
    }
}

// 汉堡菜单图标
.menu-icon {
    width: 36rpx;
    height: 24rpx;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.menu-line {
    width: 100%;
    height: 4rpx;
    background: #5a3a3a;
    border-radius: 2rpx;
    transition: all 0.3s ease;

    &.open:nth-child(1) {
        transform: translateY(13.5rpx) rotate(45deg);
    }
    &.open:nth-child(2) {
        opacity: 0;
    }
    &.open:nth-child(3) {
        transform: translateY(-13.5rpx) rotate(-45deg);
    }
}

// 侧边栏遮罩
.sidebar-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0);
    z-index: 50;
    pointer-events: none;
    transition: background 0.3s ease;

    &.active {
        background: rgba(0, 0, 0, 0.4);
        pointer-events: auto;
    }
}

// 左侧侧边栏（抽屉：默认移出屏幕，激活时滑入）
.sidebar {
    position: fixed;
    top: 0;
    left: 0;
    width: 70vw;
    max-width: 560rpx;
    height: 100vh;
    background: linear-gradient(180deg, #fff5ee 0%, #ffd6c0 100%);
    z-index: 51;
    display: flex;
    flex-direction: column;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    box-shadow: 8rpx 0 40rpx rgba(0, 0, 0, 0.15);

    &.active {
        transform: translateX(0);
    }
}

// 侧边栏头部
.sidebar-header {
    display: flex;
    align-items: center;
    padding: 100rpx 32rpx 24rpx;
    border-bottom: 2rpx solid rgba(192, 81, 63, 0.12);
}

.sidebar-title {
    font-size: 36rpx;
    font-weight: 700;
    color: #3d2c2c;
}

// 侧边栏滚动区域
.sidebar-body {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 20rpx 24rpx;
    box-sizing: border-box;
}

.sidebar-loading,
.sidebar-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 160rpx;
    color: #b0a098;
    font-size: 26rpx;
}

.empty-icon-text {
    font-size: 64rpx;
    margin-bottom: 16rpx;
}
.empty-desc {
    font-size: 26rpx;
    color: #b0a098;
}

// 侧边栏会话卡片
.sidebar-card {
    position: relative;
    background: rgba(255, 255, 255, 0.92);
    border-radius: 18rpx;
    margin-bottom: 14rpx;
    box-shadow: 0 4rpx 16rpx rgba(0, 0, 0, 0.06);
    border: 1rpx solid rgba(192, 81, 63, 0.08);
    overflow: hidden;
    transition: transform 0.15s ease;

    // 左侧渐变色条
    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 8rpx;
        background: linear-gradient(180deg, #e8735a, #f4a261);
        border-radius: 18rpx 0 0 18rpx;
    }

    &:active {
        transform: scale(0.97);
    }
}

// 卡片主内容区
.sidebar-card-main {
    padding: 18rpx 26rpx 18rpx 36rpx;
}

.sidebar-card-summary {
    font-size: 28rpx;
    color: #3d2c2c;
    line-height: 1.4;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-bottom: 8rpx;
}

.sidebar-card-meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.sidebar-card-date {
    font-size: 22rpx;
    color: #a08070;
}

.sidebar-card-count {
    font-size: 20rpx;
    color: #c0513f;
    background: rgba(192, 81, 63, 0.1);
    padding: 4rpx 16rpx;
    border-radius: 16rpx;
    font-weight: 500;
}

// 报告标识区域
.sidebar-card-report {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12rpx 0;
    background: linear-gradient(90deg, rgba(232, 115, 90, 0.08), rgba(244, 162, 97, 0.08));
    border-top: 1rpx dashed rgba(192, 81, 63, 0.15);
    transition: all 0.2s ease;

    &:active {
        background: linear-gradient(90deg, rgba(232, 115, 90, 0.15), rgba(244, 162, 97, 0.15));
    }

    .report-text {
        font-size: 24rpx;
        color: #c0513f;
        font-weight: 500;
    }
}

// 侧边栏底部退出按钮
.sidebar-footer {
    padding: 28rpx 24rpx;
    border-top: 2rpx solid rgba(192, 81, 63, 0.12);
}

.switch-mode-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 22rpx;
    margin-bottom: 20rpx; // 与退出登录按钮的间距
    background: #f7f3f1;
    border: 2rpx solid rgba(192, 81, 63, 0.25);
    border-radius: 18rpx;

    &:active {
        opacity: 0.85;
        transform: scale(0.97);
    }
}

.switch-mode-label {
    font-size: 30rpx;
    color: #c0513f;
    font-weight: 600;
}

.logout-btn-sidebar {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 22rpx;
    background: linear-gradient(135deg, #e8735a 0%, #c0513f 100%);
    border-radius: 18rpx;
    box-shadow: 0 4rpx 16rpx rgba(192, 81, 63, 0.25);

    &:active {
        opacity: 0.85;
        transform: scale(0.97);
    }
}

.logout-label {
    font-size: 30rpx;
    color: #ffffff;
    font-weight: 600;
}

// 历史详情弹窗
.detail-mask {
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 200;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 30rpx;
    box-sizing: border-box;
}

.detail-panel {
    width: 100%;
    height: 70vh;
    background: #fff;
    border-radius: 24rpx;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.detail-header {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 28rpx 32rpx;
    border-bottom: 1rpx solid #f0e8e4;
    flex-shrink: 0;
}

.detail-title {
    font-size: 32rpx;
    font-weight: 700;
    color: #3d2c2c;
}

.detail-body {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 24rpx 32rpx;
    box-sizing: border-box;
}

// 消息行：左右布局
.detail-msg {
    display: flex;
    align-items: flex-start;
    margin-bottom: 24rpx;
    &:last-child {
        margin-bottom: 0;
    }
    // 用户消息头像在右
    &.user {
        flex-direction: row-reverse;
    }
}

// 头像圆圈
.detail-avatar {
    width: 80rpx;
    height: 80rpx;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    /* 「小酒窝」3字需放在圆内接矩形内：3*18=54rpx < 80/1.414≈56rpx，恰好容纳不溢出 */
    font-size: 18rpx;
    font-weight: 700;
    flex-shrink: 0;
    &.bot {
        background: linear-gradient(135deg, #f4a261, #e8735a);
        color: #fff;
        margin-right: 16rpx;
    }
    &.user {
        background: linear-gradient(135deg, #a0c4ff, #7eb8da);
        color: #fff;
        margin-left: 16rpx;
    }
}

// 气泡
.detail-bubble {
    padding: 16rpx 24rpx;
    border-radius: 20rpx;
    max-width: 75%;
    line-height: 1.6;
    font-size: 28rpx;
    word-break: break-word;
    overflow: hidden;
    box-sizing: border-box;

    &.bot {
        background: #f8f4f2;
        color: #3d2c2c;
        border-top-left-radius: 4rpx;
    }
    &.user {
        background: linear-gradient(135deg, #95d5b2 0%, #74c69d 100%);
        color: #1b4332;
        border-top-right-radius: 4rpx;
    }
}

.detail-content {
    font-size: 28rpx;
    word-break: break-word;
}

.detail-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20rpx 32rpx;
    border-top: 1rpx solid #f0e8e4;
    flex-shrink: 0;
}

.detail-close-btn {
    font-size: 28rpx;
    color: #c0513f;
    font-weight: 600;
    padding: 12rpx 60rpx;
    border-radius: 30rpx;
    background: rgba(192, 81, 63, 0.06);

    &:active {
        opacity: 0.7;
    }
}

// 结束对话弹窗
.end-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
}

.end-panel {
    width: 600rpx;
    background: #fff;
    border-radius: 28rpx;
    padding: 48rpx 40rpx 40rpx;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 20rpx 60rpx rgba(0, 0, 0, 0.15);
    box-sizing: border-box;
}

.end-panel-title {
    font-size: 36rpx;
    font-weight: 700;
    color: #3d2c2c;
    margin-bottom: 16rpx;
}

// 弹窗描述文案
.end-panel-desc {
    width: 100%;
    font-size: 26rpx;
    color: #8a7a72;
    line-height: 1.6;
    text-align: center;
    margin-bottom: 40rpx;
}

// 按钮容器（取消/确认并排，用 margin 间距替代 gap 保证兼容性）
.end-panel-btns {
    width: 100%;
    display: flex;
}

.end-btn {
    flex: 1;
    padding: 22rpx 0;
    border-radius: 24rpx;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;

    & + .end-btn {
        margin-left: 20rpx;
    }
    &:active {
        opacity: 0.8;
    }
}

.end-btn-secondary {
    background: #faf5f0;
    border: 1rpx solid rgba(90, 58, 58, 0.08);
    .end-btn-text {
        color: #8a7a72;
        font-size: 30rpx;
        font-weight: 500;
    }
}

// 主按钮（确认）
.end-btn-primary {
    background: linear-gradient(135deg, #f4a261, #e8735a);
    box-shadow: 0 6rpx 20rpx rgba(244, 162, 97, 0.3);
    .end-btn-text {
        color: #fff;
        font-size: 30rpx;
        font-weight: 600;
    }
}

// 聊天区域（悬浮于背景之上，可滚动）
.chat-area {
    position: absolute;
    left: 20rpx;
    right: 20rpx;
    bottom: 110rpx;
    max-height: 34vh;
    z-index: 3;
    overflow-y: auto;

    .chat-list {
        padding-bottom: 10rpx;
    }

    .message-item {
        margin-bottom: 6rpx;
        animation: fadeIn 0.3s ease;
    }

    .message-bubble {
        display: inline-block;
        max-width: 78%;
        padding: 6rpx 16rpx;
        background: rgba(0, 0, 0, 0.55);
        border-radius: 24rpx;
        line-height: 1.3;
        font-size: 26rpx;
        color: #ffffff;
        word-break: break-all;
    }

    // 思考中消息气泡样式
    .thinking-bubble {
        .thinking-content {
            display: inline-flex;
            align-items: center;
        }

        .thinking-text {
            color: #ffd700;
        }

        .thinking-dots {
            display: inline-flex;
            margin-left: 8rpx;

            .dot {
                width: 8rpx;
                height: 8rpx;
                background: #ffd700;
                border-radius: 50%;
                margin: 0 3rpx;
                animation: dotBounce 1.4s ease-in-out infinite;

                &:nth-child(1) {
                    animation-delay: 0s;
                }
                &:nth-child(2) {
                    animation-delay: 0.2s;
                }
                &:nth-child(3) {
                    animation-delay: 0.4s;
                }
            }
        }
    }

    .bot-name {
        color: #ffd700;
        font-weight: 600;
        margin-right: 4rpx;
    }

    .user-name {
        color: #00d4ff;
        font-weight: 600;
        margin-right: 4rpx;
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20rpx);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

// 思考中点点动画
@keyframes dotBounce {
    0%,
    80%,
    100% {
        transform: translateY(0);
        opacity: 0.4;
    }
    40% {
        transform: translateY(-10rpx);
        opacity: 1;
    }
}

// 底部输入区域
.input-area {
    position: absolute;
    left: 24rpx;
    right: 24rpx;
    bottom: 20rpx;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 50rpx;
    padding: 12rpx 12rpx 12rpx 20rpx;
    z-index: 4;
    box-shadow: 0 8rpx 32rpx rgba(0, 0, 0, 0.3);

    .input-wrapper {
        display: flex;
        align-items: center;
        position: relative;
    }

    // 输入内容容器（用于切换动画）
    .input-content {
        flex: 1;
        display: flex;
        align-items: center;
        opacity: 1;
        transform: translateX(0);
        transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);

        &.hidden {
            position: absolute;
            left: 80rpx;
            right: 0;
            opacity: 0;
            transform: translateX(20rpx);
            pointer-events: none;
        }
    }

    // 切换按钮样式（语音/键盘切换）
    .switch-btn {
        width: 64rpx;
        height: 64rpx;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 16rpx;
        border-radius: 32rpx;
        transition: all 0.3s ease;

        &:active {
            background: rgba(254, 44, 85, 0.1);
            transform: scale(0.95);
        }

        .switch-icon {
            width: 40rpx;
            height: 40rpx;
            object-fit: contain; // 对应原 image 的 aspectFit
            transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);

            &.rotate {
                transform: rotate(180deg);
            }
        }
    }

    // 键盘输入框样式
    .chat-input {
        flex: 1;
        height: 72rpx;
        font-size: 30rpx;
        color: #333333;
        caret-color: #fe2c55;
        background: rgba(0, 0, 0, 0.08);
        border-radius: 36rpx;
        padding: 0 24rpx;
        margin-right: 12rpx;
        border: none; // 重置原生input默认边框
        outline: none; // 去除聚焦轮廓
        box-sizing: border-box;

        &::placeholder {
            color: rgba(0, 0, 0, 0.4);
        }
    }

    // 发送按钮样式
    .send-btn {
        width: 100rpx;
        height: 64rpx;
        background: rgba(0, 0, 0, 0.08);
        border-radius: 32rpx;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all 0.3s ease;
        flex-shrink: 0;

        span {
            font-size: 28rpx;
            color: rgba(0, 0, 0, 0.4);
        }

        &.active {
            background: linear-gradient(135deg, #fe2c55 0%, #ff6b8a 100%);
            box-shadow: 0 4rpx 16rpx rgba(254, 44, 85, 0.4);

            span {
                color: #ffffff;
                font-weight: 600;
            }
        }
    }

    // 语音输入区域
    .voice-content {
        justify-content: center;
    }

    .voice-input-wrap {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 72rpx;
        background: #e9e5e3;
        border-radius: 36rpx;
        margin: 0 10rpx;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        user-select: none; // 防止按住说话时选中文本

        .voice-text {
            font-size: 28rpx;
            color: #000000;
            letter-spacing: 4rpx;
        }

        &.recording {
            background: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%);

            .voice-text {
                color: #333333;
                font-weight: 500;
            }
        }
    }

    // 录制时悬浮波纹（输入框上方）
    .floating-wave {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 106rpx;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 24rpx 40rpx;
        background: rgba(255, 255, 255, 0.95);
        border-radius: 40rpx;
        box-shadow: 0 8rpx 32rpx rgba(0, 0, 0, 0.2);

        // 波纹条容器（相邻条用 margin 间距，替代 gap 保证兼容性）
        .fw-bars {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .fw-bar {
            width: 6rpx;
            background: linear-gradient(180deg, #fe2c55 0%, #ff6b8a 100%);
            border-radius: 3rpx;
            animation: waveBar 0.5s ease-in-out infinite;

            & + .fw-bar {
                margin-left: 6rpx;
            }

            &:nth-child(1) {
                height: 20rpx;
                animation-delay: 0s;
            }
            &:nth-child(2) {
                height: 32rpx;
                animation-delay: 0.1s;
            }
            &:nth-child(3) {
                height: 44rpx;
                animation-delay: 0.2s;
            }
            &:nth-child(4) {
                height: 56rpx;
                animation-delay: 0.3s;
            }
            &:nth-child(5) {
                height: 44rpx;
                animation-delay: 0.4s;
            }
            &:nth-child(6) {
                height: 32rpx;
                animation-delay: 0.5s;
            }
            &:nth-child(7) {
                height: 20rpx;
                animation-delay: 0.6s;
            }
        }

        .fw-time {
            margin-top: 16rpx;
            font-size: 30rpx;
            color: #333333;
            font-weight: 600;
            text-align: center;
        }
    }
}

// 波纹条动画
@keyframes waveBar {
    0%,
    100% {
        transform: scaleY(0.4);
        opacity: 0.4;
    }
    50% {
        transform: scaleY(1);
        opacity: 1;
    }
}
</style>
